/**
 * NotificationManagement Service
 * 알림 관리 비즈니스 로직 담당
 */
import { TemplateTypeConfig, NotificationTemplateType } from '../models/NotificationManagement';

export class NotificationManagementService {
  /**
   * 템플릿 타입별 설정 조회
   */
  getTemplateTypeConfig(type: NotificationTemplateType): TemplateTypeConfig {
    const configs: Record<NotificationTemplateType, TemplateTypeConfig> = {
      welcome: {
        bgColor: 'bg-blue-100',
        borderColor: 'border-blue-200',
        textColor: 'text-blue-800',
        label: '환영',
      },
      reminder: {
        bgColor: 'bg-yellow-100',
        borderColor: 'border-yellow-200',
        textColor: 'text-yellow-800',
        label: '알림',
      },
      promotion: {
        bgColor: 'bg-purple-100',
        borderColor: 'border-purple-200',
        textColor: 'text-purple-800',
        label: '프로모션',
      },
      notice: {
        bgColor: 'bg-green-100',
        borderColor: 'border-green-200',
        textColor: 'text-green-800',
        label: '공지',
      },
    };

    return configs[type];
  }

  /**
   * 템플릿 타입 설정 맵 생성
   */
  createTemplateTypeConfigMap(): Record<NotificationTemplateType, TemplateTypeConfig> {
    return {
      welcome: this.getTemplateTypeConfig('welcome'),
      reminder: this.getTemplateTypeConfig('reminder'),
      promotion: this.getTemplateTypeConfig('promotion'),
      notice: this.getTemplateTypeConfig('notice'),
    };
  }

  /**
   * 날짜 포맷팅
   */
  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  /**
   * 날짜 시간 포맷팅
   */
  formatDateTime(dateString: string): string {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  }

  /**
   * 고객 활성 상태 스타일 조회
   */
  getCustomerActiveStyle(isActive: boolean): string {
    return isActive ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800';
  }

  /**
   * 발송 상태 스타일 조회
   */
  getSendHistoryStatusStyle(status: 'pending' | 'completed' | 'failed'): string {
    const styles = {
      completed: 'bg-green-100 text-green-800',
      pending: 'bg-yellow-100 text-yellow-800',
      failed: 'bg-red-100 text-red-800',
    };
    return styles[status];
  }

  /**
   * 발송 상태 라벨 조회
   */
  getSendHistoryStatusLabel(status: 'pending' | 'completed' | 'failed'): string {
    const labels = {
      completed: '완료',
      pending: '진행중',
      failed: '실패',
    };
    return labels[status];
  }
}

export const notificationManagementService = new NotificationManagementService();
